import { useState } from "react";
import { ImagePlus, LayoutTemplate, MessageSquare, Megaphone, LayoutGrid, Share2, LayoutPanelTop, BadgeCheck, Star, DollarSign, ShieldCheck, AtSign, FileText, ListPlus } from "lucide-react";
import { HeroSettings } from "./HeroSettings";
import { PopupSettings } from "./PopupSettings";
import { MarketingBanner } from "./MarketingBanner";
import { CategorySettings } from "./CategorySettings";
import { SocialLinksSettings } from "./SocialLinksSettings";
import { InfoBoxesSettings } from "./InfoBoxesSettings";
import { VerifyPromoSettings } from "./VerifyPromoSettings";
import { FeaturedSettings } from "./FeaturedSettings";
import { PaidFeaturedAdmin } from "./PaidFeaturedAdmin";
import { SafetyNotesSettings, SiteEmailsSettings, HomeFeedSettings } from "./SiteContentSettings";
import { InfoPagesSettings } from "./InfoPagesSettings";
import { BannerTemplatesSettings } from "./BannerTemplatesSettings";
import { PanelTop } from "lucide-react";

const SECTIONS = [
  { id: "search-images", label: "Search Hero Images", icon: ImagePlus, render: () => <HeroSettings part="strip" /> },
  { id: "hero", label: "Homepage Hero", icon: LayoutTemplate, render: () => <HeroSettings /> },
  { id: "popups", label: "Popups", icon: MessageSquare, render: () => <PopupSettings /> },
  { id: "banners", label: "Homepage Feature Banner", icon: Megaphone, render: () => <MarketingBanner /> },
  { id: "categories", label: "Category Tiles", icon: LayoutGrid, render: () => <CategorySettings /> },
  { id: "info-boxes", label: "Info Boxes", icon: LayoutPanelTop, render: () => <InfoBoxesSettings /> },
  { id: "verify-promo", label: "Get Verified Banner", icon: BadgeCheck, render: () => <VerifyPromoSettings /> },
  { id: "featured", label: "Featured Spotlight", icon: Star, render: () => <FeaturedSettings /> },
  { id: "paid-featured", label: "Paid Featured Spots", icon: DollarSign, render: () => <PaidFeaturedAdmin /> },
  { id: "social", label: "Social Links", icon: Share2, render: () => <SocialLinksSettings /> },
  { id: "safety", label: "Ad Safety Box", icon: ShieldCheck, render: () => <SafetyNotesSettings /> },
  { id: "fresh-feed", label: "Loading More", icon: ListPlus, render: () => <HomeFeedSettings /> },
  { id: "site-emails", label: "Site Email Addresses", icon: AtSign, render: () => <SiteEmailsSettings /> },
  { id: "info-pages", label: "Info Pages", icon: FileText, render: () => <InfoPagesSettings /> },
  { id: "banner-templates", label: "Profile Banner Templates", icon: PanelTop, render: () => <BannerTemplatesSettings /> },
];
const KEY = "cp_admin_home_section";

export function HomepageSettings() {
  const [sec, setSec] = useState(() => (SECTIONS.some((s) => s.id === localStorage.getItem(KEY)) ? localStorage.getItem(KEY) : SECTIONS[0].id));
  const pick = (id) => { setSec(id); localStorage.setItem(KEY, id); };
  const active = SECTIONS.find((s) => s.id === sec);
  return (
    <div data-testid="homepage-settings">
      <nav className="flex flex-wrap gap-2 mb-5" data-testid="homepage-submenu">
        {SECTIONS.map((s) => (
          <button key={s.id} onClick={() => pick(s.id)} data-testid={`homepage-sec-${s.id}`} aria-current={sec === s.id ? "page" : undefined}
            className={`inline-flex items-center gap-2 px-4 h-10 rounded-xl border text-sm font-medium shadow-sm transition-colors ${sec === s.id ? "border-[#F5551E] bg-[#FFF4F0] text-[#F5551E]" : "border-slate-200 bg-white text-[#12234A] hover:border-[#F5551E]/50"}`}>
            <s.icon size={16} className="text-[#F5551E]" /> {s.label}
          </button>
        ))}
      </nav>
      <div key={sec}>{active.render()}</div>
    </div>
  );
}
